export const supportUrl = "https://laddition.ma/support/open.php/";

const TLD = window.location.hostname.split(".").slice(-1)[0];

const productionUrl = `https://laddition.${TLD}/api`;
const devUrl = "http://localhost:8080";

export const apiUrl =
  process.env.NODE_ENV === "production" ? productionUrl : devUrl;

export const amplitude = "https://amplitude.com/api/2/events/segmentation";
